import styled from 'styled-components';
import theme from '@raptormaps/theme';
import { TextInput } from '@raptormaps/text-input';
import { Button } from '@raptormaps/button';

export const CancelOrderModalBody = styled.table`
  text-align: center;
`;

export const CancelOrderModalTitle = styled.div`
  text-align: center;
`;

export const CancelOrderModalConfirmBtn = styled.div`
  margin-right: 15px;
`;

export const OrderDataItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 8px;
  background-color: ${theme.colors.neutral_100};
  padding: 8px;
  border-radius: 4px;

  svg {
    width: 12px;
  }
  :hover {
    cursor: pointer;
    background-color: ${theme.colors.primary_200};
  }
`;

export const GroupedInput = styled(TextInput)`
  width: 250px;
  height: 40px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;
export const GroupedButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 'none';
`;
